export default {
  getDeepLink (state) {
    return state.selectedDeepLink
  }
}
